import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=b3cc58ba&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3cc58ba')) {
      api.createRecord('b3cc58ba', component.options)
    } else {
      api.reload('b3cc58ba', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=b3cc58ba&", function () {
      api.rerender('b3cc58ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AXi48IWqYpf0/JS/offershelp.vue"
export default component.exports